export default __webpack_public_path__ + "static/robot-66df389689ea967ebbcb6a918fed0b92.png";